export const SET_RESPONSIVE_STATE = "set_responsive_state";

export const SET_TRANSLATION = "set_translation";

export const SET_USER_TOKEN = "set_user_token";
